"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMyEmployee = exports.parseMyEmployeesVacancies = exports.parseMyEmployees = void 0;
const types_1 = require("api/references/structuralUnitsUpgraded/types");
const types_2 = require("api/documents/human-resources/assign-submissions/types");
const helper_1 = require("api/helper");
const useCreateOrUpdateItems_1 = require("src/modules/documents/hr/assign-submissions/store/useCreateOrUpdateItems");
const parsers_1 = require("api/parsers/parsers");
const parsers_2 = require("api/documents/human-resources/assign-submissions/parsers");
const parseMyEmployees = (response) => {
    if (response.content === null)
        return { data: null, errors: response.errors, status: response.status };
    const myEmployees = response.content;
    try {
        return {
            data: myEmployees.data.map(el => {
                const salaryType = el.relationships.structuralUnit.data.relationships.contract?.data.relationships.workInfo?.data.attributes.salaryType;
                const currency = el.relationships.structuralUnit.data.relationships.contract?.data.relationships.workInfo?.data.relationships.currency;
                const currencyName = currency?.data?.attributes?.code;
                const workInfo = el.relationships.structuralUnit.data.relationships.contract?.data.relationships.workInfo?.data.attributes.salaryAmount || null;
                const salaryTypeOption = parsers_2.salaryTypeOptionsV2.find(el => el.id === String(salaryType));
                return {
                    id: el.id,
                    IsAuthorizedAccount: el.attributes.IsAuthorizedAccount,
                    fullName: el.relationships.user.data.attributes.fullname,
                    structuralUnit: el.relationships.structuralUnit.data.relationships.parentUnit?.data.attributes.fullName,
                    positions: el.relationships.structuralUnit.data.attributes.name,
                    salaryAmount: salaryTypeOption ? salaryTypeOption.id === String(types_2.SalaryTypeV2.FIXED) ? workInfo + ' ' + currencyName : salaryTypeOption.label : '',
                    minSalaryAmount: el.relationships.structuralUnit.data.attributes.positionStatus === types_1.PositionStatus.STUFF_MEMBER
                        ? el.relationships.structuralUnit?.data.attributes.minSalaryAmount : null,
                    maxSalaryAmount: el.relationships.structuralUnit.data.attributes.positionStatus === types_1.PositionStatus.STUFF_MEMBER
                        ? el.relationships.structuralUnit?.data.attributes.maxSalaryAmount : null,
                    startDate: (0, parsers_1.transformDate)(el.relationships.structuralUnit.data.relationships.contract?.data.attributes.startDate),
                    endDate: (0, parsers_1.nullableTransformDate)(el.relationships.structuralUnit.data.relationships.contract?.data.attributes.endDate || null),
                    createdAt: (0, parsers_1.transformDate)(el.attributes.createdAt),
                    updatedAt: (0, parsers_1.transformDate)(el.attributes.updatedAt)
                };
            }),
            status: response.status,
            errors: null,
            meta: (0, parsers_1.transformPagination)(myEmployees.meta)
        };
    }
    catch (err) {
        (0, helper_1.throwException)(err);
        return helper_1.errorObject;
    }
};
exports.parseMyEmployees = parseMyEmployees;
const parseMyEmployeesVacancies = (response) => {
    if (response.content === null)
        return { data: null, errors: response.errors, status: response.status };
    const myEmployeesVacancies = response.content;
    try {
        return {
            data: myEmployeesVacancies.data.map(el => {
                return {
                    id: el.id,
                    structuralUnit: el.relationships.parentUnit?.data.attributes.fullName,
                    positions: el.attributes.name,
                    minSalaryAmount: el.attributes.positionStatus === types_1.PositionStatus.STUFF_MEMBER
                        ? el.attributes.minSalaryAmount : null,
                    maxSalaryAmount: el.attributes.positionStatus === types_1.PositionStatus.STUFF_MEMBER
                        ? el.attributes.maxSalaryAmount : null,
                    createdAt: (0, parsers_1.transformDate)(el.attributes.createdAt),
                    updatedAt: (0, parsers_1.transformDate)(el.attributes.updatedAt)
                };
            }),
            status: response.status,
            errors: null,
            meta: (0, parsers_1.transformPagination)(myEmployeesVacancies.meta)
        };
    }
    catch (err) {
        (0, helper_1.throwException)(err);
        return helper_1.errorObject;
    }
};
exports.parseMyEmployeesVacancies = parseMyEmployeesVacancies;
const parseMyEmployee = (response) => {
    if (response.content === null)
        return { data: null, errors: response.errors, status: response.status };
    const myEmployee = response.content;
    try {
        const date = new Date();
        date.setDate(date.getDate() + 30);
        const workInfoItem = myEmployee.data.relationships.structuralUnit.data.relationships.contract?.data.relationships.workInfo?.data.relationships.items.data.map(salary => salary.attributes.salaryAmount) || [];
        const workInfo = myEmployee.data.relationships.structuralUnit.data.relationships.contract?.data.relationships.workInfo?.data.attributes.salaryAmount || null;
        const workInfoData = myEmployee.data.relationships.structuralUnit.data.relationships.contract?.data.relationships.workInfo !== null
            ? myEmployee.data.relationships.structuralUnit.data.relationships.contract?.data.relationships.workInfo?.data
            : null;
        const alertTime = workInfoData === null
            ? false
            : workInfoData?.relationships.project?.data.attributes?.endDate
                ? date > new Date(workInfoData.relationships?.project.data.attributes?.endDate)
                : false;
        return {
            data: {
                id: myEmployee.data.id,
                IsAuthorizedAccount: myEmployee.data.attributes.IsAuthorizedAccount,
                fullName: myEmployee.data.relationships.user.data.attributes.fullname,
                email: myEmployee.data.relationships.user.data.attributes.email,
                mobileNumber: myEmployee.data.relationships.user.data.attributes.mobileNumber,
                structuralUnit: myEmployee.data.relationships.structuralUnit.data.relationships.parentUnit?.data.attributes.name,
                positions: myEmployee.data.relationships.structuralUnit.data.attributes.name,
                salaryAmount: workInfoItem?.length > 0 ? workInfoItem : [workInfo],
                workInfo: workInfoData !== null ? (0, parsers_2.parseWorkTypesSalaryAmountV2)(workInfoData, alertTime) : useCreateOrUpdateItems_1.initialWorkInfoV2,
                minSalaryAmount: myEmployee.data.relationships.structuralUnit.data.attributes.positionStatus === types_1.PositionStatus.STUFF_MEMBER
                    ? myEmployee.data.relationships.structuralUnit?.data.attributes.minSalaryAmount : null,
                maxSalaryAmount: myEmployee.data.relationships.structuralUnit.data.attributes.positionStatus === types_1.PositionStatus.STUFF_MEMBER
                    ? myEmployee.data.relationships.structuralUnit?.data.attributes.maxSalaryAmount : null,
                startDate: (0, parsers_1.transformDate)(myEmployee.data.relationships.structuralUnit.data.relationships.contract.data.attributes.startDate),
                endDate: (0, parsers_1.nullableTransformDate)(myEmployee.data.relationships.structuralUnit.data.relationships.contract.data.attributes.endDate || null),
                actualAddress: myEmployee.data.relationships.user.data.attributes.actualAddress,
                legalAddress: myEmployee.data.relationships.user.data.attributes.legalAddress,
                identityNumber: myEmployee.data.relationships.user.data.attributes.identityNumber,
                birthDate: (0, parsers_1.nullableTransformDate)(myEmployee.data.relationships.user.data.attributes.birthDate)
            },
            status: response.status,
            errors: null
        };
    }
    catch (err) {
        (0, helper_1.throwException)(err);
        return helper_1.errorObject;
    }
};
exports.parseMyEmployee = parseMyEmployee;
